import React, {useEffect, useState} from "react";
import common from "../../translations/it/common.json";
import Button from "../../components/Button/Button";
import Table from "../../components/table/Table";
import Spinner from "../../components/spinner/Spinner";
import SportelliService from "../../services/SportelliService";
import Pagination from "../../components/pagination/Pagination";
import InserisciSportello from "./InserimentoModificaSportello/InserisciSportello";
import ModaleOrari from "./OrariSportello/ModaleOrari";
import style from "./ElencoSportelli.module.css"
import {useHistory} from "react-router";
import ModificaSportello from "./InserimentoModificaSportello/ModificaSportello";
import MediaQueryUtils from "../../utils/MediaQueryUtils";
import {useDispatch, useSelector} from "react-redux";
import RicercaSportelli from "./RicercaSportelli/RicercaSportelli";
import {setSearch} from "../../actions/IndexActions";
import Utils from "../../utils/Utils";

function ElencoSportelli(props) {

    const [flagButtonModale, setFlagButtonModale] = useState(false)
    const [rows, setRows] = useState([])
    const [pagination, setPagination] = useState({size: 5, page: 0, sort: "comune ->> 'descrizione'", order: "asc", paginazione: true})
    const [modalBody] = useState(<InserisciSportello getSportelli={getSportelli} />)
    const [modalBodyModifica,setModalBodyModifica] = useState(null)
    const [modalBodyOrari,setModalBodyOrari] = useState(null)
    const [showSpinner, setShowSpinner] = useState(false)
    const history = useHistory()
    const button = useSelector(state => state.searchReducer)
    const dispatch = useDispatch()
    let isPageWide = MediaQueryUtils('(min-width: 1200px)')
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}
    const cols = [
        {name: "Comune", key: "comune", typeSort: "ASC"},
        {name: "Indirizzo", key: "indirizzo", typeSort: "ASC"},
        {name: "Referente", key: "referente", typeSort: "ASC"},
        {name: "Telefono", key: "telefono", typeSort: "ASC"},
        {name: "Email", key: "email", typeSort: "ASC"},
        {type: "button", key: "id", onClick:onClickButtonVediOrari,typeButton:"White",text:"Vedi Orari",className:style.buttonTable},
        {type: "button", key: "id", onClick:onClickButtonModifica,typeButton:"White",text:"Modifica",className:style.buttonTable,check:"checkSportello"}
    ]

    useEffect(() => {
        getSportelli()
    }, [pagination.page,pagination.sort,pagination.order])

    function onClickButtonVediOrari(idSportello){
        history.location.sportelli.forEach(sportello => {
            if(sportello.id === idSportello){
                let sportelloConOrari = {
                    nomeSportello: "Sportello " + sportello.comune.descrizione + ", " + sportello.indirizzo,
                    orari : sportello.orari,
                    appuntamento:sportello.appuntamento,
                    note:sportello.note
                }
                setModalBodyOrari(<ModaleOrari sportelloConOrari={sportelloConOrari}/>)
            }
        })
        document.getElementById("Orari").click();
    }

    function onClickButtonModifica(idSportello){
        history.location.sportelli.forEach(sportello => {
            if(sportello.id === idSportello){
                setModalBodyModifica(<ModificaSportello state={sportello} getSportelli={getSportelli}/>)
            }
        })
        document.getElementById("ModificaSportello").click();
    }

    function getSportelli() {
        setShowSpinner(true)
        SportelliService.getSportelli(pagination).then(res => {
            history.push({
                sportelli:res.data.content
            })
            let newPagination = {...pagination}
            newPagination.totalPages = res.data.totalPages
            newPagination.totalElements = res.data.totalElements
            let newRows = JSON.parse(JSON.stringify(res.data.content))
            newRows.forEach(sportello => {
                sportello.comune = sportello.comune.descrizione
                sportello.orari = sportello.id
            })
            setRows(newRows)
            setPagination(newPagination)
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation GET Sportelli: " + reason)
            setRows([])
            setShowSpinner(false)
        })
    }

    function changePage(newPage) {
        let newPagination = {...pagination}
        newPagination.page = newPage
        setPagination(newPagination)
    }

    function setPaginationSort(sort,order){
        let newPagination = {...pagination}
        if(sort === "comune"){
            newPagination.sort= "comune ->> 'descrizione'"
        }else{
            newPagination.sort = sort
        }
        newPagination.order = order
        setPagination(newPagination)
    }

    function onClickInserisciAnnulla(){
        if(button && button.buttonFlag){
            dispatch(setSearch(false))
            setFlagButtonModale(true)
            getSportelli()
        }

    }

    function onClickInserisci(){
        setFlagButtonModale(false)
    }

    function renderButtonBody(){
        if(!flagButtonModale) {
            return (
                <Button
                    id={"inserisciSportello"}
                    style={{height: "60px", width: "300px"}}
                    typeButton={"Blue"}
                    text={common.ElencoSportelli.buttonInserisci}
                    dataTarget={"modalInserisciSportelli"}
                    dataToggle={"modal"}
                    dataBackdrop={"static"}
                    dataKeyboard={false}
                    body={modalBody}
                    header={"Dati Sportello"}
                />
            )
        }
        else{
            return (
                <Button
                    id={"inserisciSportello"}
                    style={{height: "60px", width: "300px"}}
                    typeButton={"Blue"}
                    text={common.ElencoSportelli.buttonInserisci}
                    dataBackdrop={"static"}
                    dataKeyboard={false}
                    onClick={onClickInserisci}
                />
            )

        }
    }

    function renderButtonBody2(){
        return (
            <Button
                id={"inserisciSportello"}
                style={{height: "60px", width: "300px"}}
                typeButton={"Blue"}
                text={"Annulla"}
                dataBackdrop={"static"}
                dataKeyboard={false}
                icon={button && button.buttonFlag && Utils.IconAnnullaElenchi()}
                onClick={onClickInserisciAnnulla}
            />
        )
    }

    return (
        <div>
            <Spinner show={showSpinner}/>
            <div className={"pt-4"}>
                <div className={"row"} style={{margin: "0", width: "100%",display:"flex",alignItems:"center"}}>
                    <div className={"col-1"} style={{marginRight:!isPageWide?"2rem":""}}>
                        <svg width={"70"} viewBox="0 0 24 24" id="it-user"
                             xmlns="http://www.w3.org/2000/svg" style={{background:"rgb(195 224 236)",borderRadius:"100px",padding:"15px"}}>
                            <path
                                d="M12 13a4 4 0 004-4V6a4 4 0 00-8 0v3a4 4 0 004 4zM9 6a3 3 0 016 0v3a3 3 0 01-6 0zm11 16h-1a7 7 0 00-14 0H4a8 8 0 0116 0z"/>
                            <path fill="none" d="M0 0h24v24H0z"/>
                        </svg>
                    </div>
                    <div className={sessioneUtente?.ruolo?.toUpperCase() !== "RAF-RDSS"?"col-6":"col-7"}  style={{display:"flex",alignItems:"center"}}>
                        <span style={{fontWeight: "bold",fontSize:"28px"}}>{common.ElencoSportelli.titolo}</span>
                    </div>
                    <div className="col-2" style={{
                        minWidth: "fit-content",
                        display: "flex",
                        justifyContent: "center",
                        minHeight: "80px"
                    }}>
                        { button && button.buttonFlag ?
                            renderButtonBody2()
                            :
                            sessioneUtente?.ruolo?.toUpperCase() === "RAF-RDS"?<></>:renderButtonBody()
                        }

                    </div>
                </div>
                <div className="col-3 pt-3">
                    <Button
                        id={"ModificaSportello"}
                        typeButton={"Blue"}
                        style={{display:"none"}}
                        dataTarget={"modalModificaSportelli"}
                        dataToggle={"modal"}
                        dataBackdrop={"static"}
                        dataKeyboard={false}
                        body={modalBodyModifica}
                        header={"Modifica Sportello"}
                    />
                </div>
                <div className="col-3 pt-3">
                    <Button
                        id={"Orari"}
                        typeButton={"Blue"}
                        style={{display:"none"}}
                        dataTarget={"modaleOrari"}
                        dataToggle={"modal"}
                        dataBackdrop={"static"}
                        dataKeyboard={false}
                        body={modalBodyOrari}
                        header={"Orari Sportello"}
                    />
                </div>
            </div>

            {button && button.buttonFlag &&
            <div>
                <RicercaSportelli getSportelli={getSportelli}/>
            </div>
            }

            <div style={{marginTop: "50px"}} className={button && button.buttonFlag && style.backgroundMode}>
                <Table
                    cols={cols}
                    rows={rows}
                    id={"tabellaSportelli"}
                    title={"Elenco Sportelli Registro"}
                    setSort={setPaginationSort}
                />
                {rows && rows.length > 0 ? <Pagination pagination={pagination} changePage={changePage}/> : <></> }
            </div>
        </div>
    );
}

export default ElencoSportelli;
